import { pipe } from 'fp-ts/function'
import { decodeJson, get, patch, put } from 'lib/request'

import { TMyProfile } from './users.codecs'

export const getMyProfile = async () => {
  return pipe(await get('api/users/me', {}), decodeJson(TMyProfile))
}

export const updateMyAvatar = async ({ file }: { file: Blob }) => {
  return pipe(
    await patch('api/users/me/avatar', {
      type: 'file',
      body: {
        file,
      },
    }),
  )
}

export const updateMyFullName = async ({ fullName }: { fullName: string }) => {
  return pipe(
    await put('api/users/me', {
      body: {
        fullName,
      },
    }),
  )
}

export const updateMyEmail = async ({ email }: { email: string }) => {
  return pipe(
    await patch('api/users/me/email', {
      body: {
        email,
      },
    }),
  )
}

export const updateMyPassword = async ({
  currentPassword,
  newPassword,
}: {
  currentPassword: string
  newPassword: string
}) => {
  return pipe(
    await patch('api/users/me/password', {
      body: {
        currentPassword,
        newPassword,
      },
    }),
  )
}
